import React from "react";
import styles from "./MobileTooltip.module.scss";
import { useIsMobile } from "~/hooks";

interface MobileTooltipProps {
  content?: string;
}

export const MobileTooltip: React.FC<MobileTooltipProps> = ({ content }) => {
  const isMobile = useIsMobile();
  if (!content || !isMobile) return null;

  return <div className={`${styles.tooltip}`}>{content}</div>;
};
